/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

export const Section = ({ children }: Props) => {
  const { spacing } = useTheme();
  return (
    <div
      css={{
        display: `flex`,
        gap: `${spacing.s}`,
        marginBottom: spacing.xs,
        'flex-direction': `column`,
      }}
    >
      {children}
    </div>
  );
};
